import { render, staticRenderFns } from "./specialistList.vue?vue&type=template&id=123f04de&"
import script from "./specialistList.vue?vue&type=script&lang=js&"
export * from "./specialistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports